exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* purgecss start ignore */\n.message-text-container[data-v-410cbfa2] {\n  position: relative;\n}\n.send-message[data-v-410cbfa2] {\n  padding: 15px 85px 10px 30px;\n}\n.send-button[data-v-410cbfa2] {\n  position: absolute;\n  bottom: 5px;\n  right: 15px;\n}\n.emoji-button[data-v-410cbfa2] {\n  position: absolute;\n  bottom: 5px;\n  right: 48px;\n}\n\n/* purgecss end ignore */\n", ""]);

// exports
